import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { FormOnColor } from "./constants.js";
import styles from "./components/MaxCharacters/styles.module.scss";
const MaxCharacters = ({ maxCharacters, maxText, length, onColor, maxWidth }) => {
  const progress = length / maxCharacters;
  const counterTextClass = classNames(styles["max-characters"], {
    [styles[`max-characters--on-dark`]]: onColor === FormOnColor.ondark,
    [styles[`max-characters--invalid`]]: progress > 1
  });
  const ariaLevel = progress > 0.95 ? "polite" : "off";
  return /* @__PURE__ */ jsx("div", { "aria-live": ariaLevel, "aria-atomic": "true", className: counterTextClass, style: { maxWidth }, children: `${length}/${maxCharacters} ${maxText ? maxText : "tegn"}` });
};
export {
  MaxCharacters as M
};
//# sourceMappingURL=MaxCharacters.js.map
